<template>
    <b-dropdown class="dropdown--secondary ml-auto" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
            <div class="section-users section-users--limited">
                <div class="section-users__images">
                    <div v-for="(avatar, index) in stringHelper.getAvatarsForDisplay(columnData)" :key="index" class="section-users__images__item">
                        <img :src="avatar" style="width: 30px;" alt=""/>
                    </div>
                </div>

                <p>
                    <span class="section-users__data">
                        <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(columnData).slice(0, 2)" :key="'1' + index">
                            <span v-if="index > 0">, </span>{{ item }}
                        </a>
                    </span>
                    <a v-for="(item, index) in stringHelper.getPermissionNamesForDisplay(columnData).slice(2, 3)" :key="'2' + index">
                        {{ item }}
                    </a>
                </p>
            </div>
        </template>

        <b-dropdown-header>
            <header class="dropdown__header-inner">
                <h4 class="heading4">Permissions</h4>

                <a v-if="false" href="#" class="link link--lg">Edit</a>
            </header>

            <ul class="rows-list">
                <li  v-for="(permission, index) in columnData" :key="index">
                    <div class="rows-list__avatar">
                        <Avatar
                            :username="permission.name"
                            :src="permission.avatar"
                            :size="30">
                        </Avatar>
                    </div>

                    <h5 class="heading5 heading5--secondary">{{ permission.name }}</h5>

                    <!-- Please add here the logic first -->
                    <template v-if="typeof permission.role !== 'undefined'">
                        <p class="ml-auto">{{ permission.role.name }}</p>
                        <a class="link-info" href="#">
                            <span class="link-info__content">{{ permission.role.description }}</span>
                        </a>
                    </template>
                </li>
            </ul>
        </b-dropdown-header>
    </b-dropdown>
</template>

<script>

import Avatar from "vue-avatar";

export default {
    props: {
        rowId: Number,
        columnData: Array,
    },

    components: {
        Avatar
    }
}
</script>

<style scoped>

</style>